<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      isOpen: this.open,
    }
  },

  methods: {
    openDetails () {
      this.isOpen = true
    },

    closeDetails () {
      this.isOpen = false
    },

    toggle () {
      this.isOpen = !this.isOpen
    },
  },

  computed: {
    triggers() {
      return {
        click: this.toggle,
      }
    }
  }
}
</script>
